import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.request.use(
  function (config) {

       config.headers["authorization"] = localStorage.getItem(
      process.env.VUE_APP_AUTH_TOKEN
    );
    return config
  },
  (error) => {
    return Promise.reject(error);
  }
);

/*
axios.interceptors.response.use(
  (response) => response, // if success, just return it

  (error) => {
    // Network errors (no response from server)
    if (!error.response) {
      console.error("Network Error:", error.message);
      alert("Unable to connect to the server. Please check your internet connection.");
      return Promise.reject(error);
    }

    const { status, data } = error.response;

    // Handle based on status codes
    switch (status) {
      case 400:
        console.warn("Bad Request:", data?.message || "Invalid input data.");
        break;
      case 403:
        alert("You don’t have permission to perform this action.");
        break;
      case 404:
        alert("Requested resource not found.");
        break;
      case 500:
        alert("Server error. Please try again later.");
        break;
      default:
        alert(data?.message || "An unexpected error occurred.");
        break;
    }

    return Promise.reject(error);
  }
);*/
export default axios;